module.exports = __webpack_public_path__ + "materialdesignicons-webfont.2cfc2e0d57d974050530.svg";


//////////////////
// WEBPACK FOOTER
// /Users/igor/Projects/onechat/admin-dashboard/src/assets/scss/icons/material-design-iconic-font/fonts/materialdesignicons-webfont.svg?v=1.8.36
// module id = ../../../../../src/assets/scss/icons/material-design-iconic-font/fonts/materialdesignicons-webfont.svg?v=1.8.36
// module chunks = styles